import http from "../plugins/http"

export const fetchStates = async ({ query = "?all=1" }: { query?: string } = {}) => {
  const data = await http.get(`/v1/public/states${query}`)
  return data
}
